import { NgxLoggerLevel } from "ngx-logger";

export const environment = {
  production: false,

  // This value will be always point to UAT
  appType: "UAT",

  // This value will be used for Mobile App Base URL, override by Git Action
  baseUrl: "https://secure9004flyer.mobibranch.com",

  // Custom Scheme for Mobile App, updated via Jenkin
  customScheme: "xxx.mobibanking.yyy",

  logger: {
    level: NgxLoggerLevel.TRACE,
    serverLogLevel: NgxLoggerLevel.OFF,
    serverLoggingUrl: '/api/v2/log'
  },
};

// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.